import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApimProductionSubscription, ApimProductType, ApimSubscriptionUpdate, ApimUser, ApimUserHistoryRecord, ApimUserSubscription, EDepositApiUser, User } from 'models';

@Injectable({
	providedIn: 'root',
})
export class ApimUserService {
	constructor(private http: HttpClient) {}

	getEDepositUser(userId: string): Observable<EDepositApiUser> {
		return this.http.get<EDepositApiUser>(`api/apim/edeposit/get/${userId}`);
	}

	getApimSubscription(userId: string): Observable<ApimUserSubscription> {
		return this.http.get<ApimUserSubscription>(`api/apim/subscription/get/${userId}`);
	}

	getUserHistory(userId: string): Observable<ApimUserHistoryRecord[]> {
		return this.http.get<ApimUserHistoryRecord[]>(`api/apim/history/get/${userId}`);
	}

	subscribeToProduction(subscription: ApimProductionSubscription): Observable<ApimUserSubscription> {
		return this.http.post<ApimUserSubscription>(`api/apim/subscribeToProduction`, subscription);
	}

	updateSubscriptionState(update: ApimSubscriptionUpdate): Observable<ApimUserSubscription> {
		return this.http.patch<ApimUserSubscription>(`api/apim/updateSubscriptionState`, update);
	}

	updateUserState(operation: 'reactivate' | 'deactivate', userId: string): Observable<User> {
		return this.http.patch<User>(`api/apim/${operation}User/${userId}`, null);
	}

	getApimUser<T>(userId: string, product: ApimProductType): Observable<T> {
		return this.http.get<T>(`api/apim/${product}/get/${userId}`);
	}

	subscribeApimUser(user: ApimUser, product: ApimProductType): Observable<string> {
		return this.http.post<string>(`api/apim/${product}/subscribe`, user);
	}

	createApimUser(user: ApimUser, product: ApimProductType): Observable<string> {
		return this.http.post<string>(`api/apim/${product}/create`, user);
	}

	updateApimUser(user: ApimUser, product: ApimProductType): Observable<string> {
		return this.http.post<string>(`api/apim/${product}/update`, user);
	}
}
